module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LQ156T3LW03-8-27-15.06e87773.pdf";